import { React, useState, useEffect, useRef } from "react";
import {
  Form,
  Button,
  Container,
  InputGroup,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { useNavigate } from "react-router-dom";
import QrScanner from "react-qr-barcode-scanner";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as RefreshIcon } from "../../assets/svg/refresh-icon.svg";
import { apiCall, apiCallAdmin } from "../../services/api-service";
import { format, parse } from "date-fns";
import { ReactComponent as NavIcon } from "../../assets/svg/nav-icon.svg";
import { useGlobal } from "../../GlobalContext";
import help from "../../assets/svg/help.svg";
import issue from "../../assets/svg/issue.svg";
import ReportAnIssueModal from "./report-an-issue-modal.js";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { getOrgLogoApi, getOrgListApi } from "./common-api";
import ProfilePopup from "./ProfilePopup";

const Header = () => {
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const navigate = useNavigate();
  const [rolePermissionList, setRolePermissionList] = useState([]);
  const [scanData, setScanData] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [displayMessage, setDisplayMessage] = useState(null);
  const [isScannerActive, setIsScannerActive] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [userType, setUserType] = useState("");
  const [firstLetter, setFirstLetter] = useState("");
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const alertRef = useRef(null);
  const [showComplaintModule, setShowComplaintModule] = useState(false);
  const [profileDetail, setProfileDetail] = useState({});
  const [orgLogo, setOrgLogo] = useState("");
  const [orgName, setOrgName] = useState("");
  let debounceTimer = null;
  const [showProfile, setShowProfile] = useState(false);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    /*  event.preventDefault();
     event.stopPropagation(); */
    /*  if (debounceTimer) {
         console.log("Double mousedown prevented!");
         return;
       }
 
        // Start debounce timer
     debounceTimer = setTimeout(() => {
         debounceTimer = null;
       }, 1000); // 500ms debounce interval */

    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setIsMenuOpen(false); // Close the alert
    }
  };

  const closeModal = () => {
    setIsScannerActive(false);
    setIsOpen(false);
  };

  const menuBoxInactive = {
    cursor: "pointer",
    width: "100px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const menuBoxActive = {
    cursor: "pointer",
    width: "100px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "3px solid #842234",
  };
  const menuBox2Inactive = {
    cursor: "pointer",
    width: "118px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const menuBox2Active = {
    cursor: "pointer",
    width: "118px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "3px solid #842234",
  };
  const menuColorActive = {
    fontSize: "15px",
    fontWeight: "700",
    color: "#842234",
  };
  const menuColorInactive = {
    fontSize: "15px",
    fontWeight: "400",
    color: "#1E1E1E",
  };
  const profileName = { fontSize: "14px", fontWeight: "700", color: "#842234" };

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0)",
      width: "400px",
      height: "474px",
      textAlign: "center",
    },
  };
  useEffect(() => {
    getOrgList();
    getRolePermission();
    getOrgLogo();
    getProfile();
  }, []);

  const [orgList, setOrgList] = useState([]);
  const getOrgList = async () => {
    console.log("Getting org list");
    const response = await getOrgListApi();
    console.log(response.data);
    if (response.status === 200) {
      console.log(response.data.orgs);
      if (response.data.success === true) {
        setOrgList(response.data.orgs ?? []);
      }
    }
  };

  const getRolePermission = async () => {
    try {
      const response = await apiCallAdmin("get", "get_role_permission/27");
      if (response?.status === 200 && response.data?.success === true) {
        setUserType(response.data.user_type);
        setRolePermissionList(response.data.role_permission ?? []);
      } else {
        setRolePermissionList([]);
      }
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
    }
  };
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        /*  setheaderDetails(response.user ?? {}); */
        setOrgLogo(response.image ?? "");
        setOrgName(response.org_name ?? "....");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handleScan = (result) => {
    console.log("scan data........", result);
    if (result) {
      setDisplayMessage("Please wait...");
      setIsScannerActive(false);
      console.log("scan data........", result.text);
      setScanData(result.text);
      checkQRCode(result.text);
    }
  };
  const handleError = (err) => {
    console.error("Scan error:", err);
    /* setErrorMessage("No QR code detected. Try again."); */
  };
  const openModal = () => {
    console.log("open modal called");

    setIsOpen(true);
    setIsScannerActive(true);
  };
  const restartScanner = () => {
    setDisplayMessage("Restarting scanner...");
    setIsScannerActive(false); // Unmount scanner
    setTimeout(() => setIsScannerActive(true), 100); // Remount scanner after a short delay
    setScanData(null); // Reset the scan result
    setErrorMessage(null); // Clear any error messages
  };

  const checkQRCode = async (url) => {
    console.log("url.........", url);
    const urlObj = new URL(url);
    const urlParams = urlObj.searchParams;

    console.log("params", urlParams);
    urlParams.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
    const qrCode = urlParams.get("r");
    console.log("params r", qrCode);
    try {
      const response = await apiCall("get", `scan/${qrCode}`);
      if (response?.status === 200 && response.data?.success === true) {
        closeModal();
        navigate("/discover-view", {
          state: {
            id: response.data.booking.id,
            date: new Date(),
            formatted_date: formatDate(new Date().toLocaleDateString()),
          },
        });
      } else if (response?.status === 500 || response?.status === 400) {
        setErrorMessage("Invalid QR Code!");
        setIsScannerActive(true);
      }
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
    }
  };

  function formatDate(inputDate) {
    if (inputDate !== undefined) {
      // Parse the input date (MM/DD/YYYY format)
      const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());

      // Format the date
      return format(parsedDate, "EEEE, dd MMM yyyy");
    } else {
      return "";
    }
  }
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  const getProfile = async () => {
    try {
      const response = await apiCallAdmin("get", "profile");

      if (response?.data?.success === true) {
        setProfileDetail(response.data.user);
        setFirstLetter(
          response.data.user.first_name
            ? response.data.user.first_name.charAt(0)
            : ""
        );
      }
    } catch (err) {
    } finally {
    }
  };

  return (
    <Container
      fluid
      className="GTWalsheimTrial sticky-top px-12"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "68px",
        background: "#ffffff",
        borderBottom: "1px solid #E5E5E5",
      }}
    >
      {showComplaintModule && (
        <ReportAnIssueModal
          onSuccess={(response) => {
            setSnackbarMessage(response.message);
            setSnackbarStatus(response.success);
            handleSnackbarShow();
            setShowComplaintModule(false);
          }}
          onCancel={() => {
            setShowComplaintModule(false);
          }}
        />
      )}
      <div>
        <NavIcon
          onClick={toggleMenu}
          className="d-lg-none"
          style={{ margin: "8px" }}
        />

        <MeetQIcon style={{ marginLeft: "8px" }} />
      </div>

      <div className="d-none d-lg-block">
        <div style={{ display: "flex", alignItems: "center" }}>
          {(checkPermission("Dashboard", "menu_permission") ||
            userType === "A" ||
            userType === "SA") && (
            <div
              onClick={() => {
                navigate("/dashboard");
              }}
              style={
                selectedMenu === "Dashboard" ? menuBox2Active : menuBox2Inactive
              }
            >
              <div
                style={
                  selectedMenu === "Dashboard"
                    ? menuColorActive
                    : menuColorInactive
                }
              >
                Dashboard
              </div>
            </div>
          )}
          {(checkPermission("Discover", "menu_permission") ||
            userType === "A" ||
            userType === "SA") && (
            <div
              onClick={() => {
                navigate("/");
              }}
              style={
                selectedMenu === "Discover" ? menuBox2Active : menuBox2Inactive
              }
            >
              <div
                style={
                  selectedMenu === "Discover"
                    ? menuColorActive
                    : menuColorInactive
                }
              >
                Discover
              </div>
            </div>
          )}
          {(checkPermission("My Bookings", "menu_permission") ||
            userType === "A" ||
            userType === "SA") && (
            <div
              onClick={() => {
                navigate("/mybooking");
              }}
              style={
                selectedMenu === "My Bookings"
                  ? menuBox2Active
                  : menuBox2Inactive
              }
            >
              <div
                style={
                  selectedMenu === "My Bookings"
                    ? menuColorActive
                    : menuColorInactive
                }
              >
                My Bookings
              </div>
            </div>
          )}
          {(checkPermission("Office - Setup", "menu_permission") ||
            userType === "A" ||
            userType === "SA") && (
            <div
              onClick={() => {
                navigate("/office-list");
              }}
              style={
                selectedMenu === "Offices" ? menuBoxActive : menuBoxInactive
              }
            >
              <div
                style={
                  selectedMenu === "Offices"
                    ? menuColorActive
                    : menuColorInactive
                }
              >
                Offices
              </div>
            </div>
          )}
          {(checkPermission("Room - Setup", "menu_permission") ||
            userType === "A" ||
            userType === "SA") && (
            <div
              onClick={() => {
                navigate("/room-list");
              }}
              style={selectedMenu === "Rooms" ? menuBoxActive : menuBoxInactive}
            >
              <div
                style={
                  selectedMenu === "Rooms" ? menuColorActive : menuColorInactive
                }
              >
                Rooms
              </div>
            </div>
          )}
          {(userType === "A" || userType === "SA") && (
            <div
              onClick={() => {
                navigate("/user-list");
              }}
              style={selectedMenu === "Users" ? menuBoxActive : menuBoxInactive}
            >
              <div
                style={
                  selectedMenu === "Users" ? menuColorActive : menuColorInactive
                }
              >
                Users
              </div>
            </div>
          )}
          {(checkPermission("Report", "menu_permission") ||
            userType === "A" ||
            userType === "SA") && (
            <div
              onClick={() => {
                navigate("/quick-report");
              }}
              style={
                selectedMenu === "Report" ? menuBoxActive : menuBoxInactive
              }
            >
              <div
                style={
                  selectedMenu === "Report"
                    ? menuColorActive
                    : menuColorInactive
                }
              >
                Report
              </div>
            </div>
          )}
          {/*  <div style={selectedMenu ==='Invoices'? menuBoxActive : menuBoxInactive}>
             <div style={selectedMenu ==='Invoices'? menuColorActive : menuColorInactive}>Invoices</div>    
         </div> */}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        {/*  <QrScanner
        onUpdate={(err, result) => {
          if (result) handleScan(result);
          else handleError(err);
        }}
        style={{ width: '300px' }}
      /> */}
        <div
          onClick={() => {
            openModal();
          }}
          style={{
            cursor: "pointer",
            width: "112px",
            height: "44px",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#842234",
          }}
        >
          <div>
            <ScanIcon />
          </div>
          &nbsp;{" "}
          <div
            style={{ fontSize: "16px", fontWeight: "500", color: "#FFFFFF" }}
          >
            Scan
          </div>
        </div>

        <div
          data-tooltip-id="report-issue"
          data-tooltip-content="Report an Issue"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setShowComplaintModule(true);
          }}
        >
          <img src={issue} alt="issue" srcSet="" width={"28px"} />
        </div>
        <Tooltip id="report-issue" />

        <div
          data-tooltip-id="help-tooltip"
          data-tooltip-content="Help"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/help");
          }}
        >
          <img src={help} alt="help" srcSet="" width={"28px"} />
        </div>
        <Tooltip id="help-tooltip" />
        <div
          onClick={() => {
            setShowProfile(!showProfile);
          }}
          style={{ cursor: "pointer" }}
        >
          {profileDetail.profile_image != null &&
            profileDetail.profile_image !== "" && (
              <img
                src={profileDetail.profile_image}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100px",
                }}
                alt="Profile"
              />
            )}
          {(profileDetail.profile_image == null ||
            profileDetail.profile_image === "") && (
            <div
              style={{
                cursor: "pointer",
                width: "44px",
                height: "44px",
                borderRadius: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFD2DB",
              }}
            >
              <div style={profileName}>{firstLetter}</div>
            </div>
          )}
        </div>
        {showProfile && (
          <ProfilePopup
            orgList={orgList}
            profileDetail={profileDetail}
            onClose={() => setShowProfile(false)}
            orgLogo={orgLogo}
            orgName={orgName}
            callProfileFunc={getProfile}
          />
        )}
      </div>
      {isOpen && (
        <div style={modalStyle.overlay}>
          <div style={modalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#1E1E1E",
                    }}
                  >
                    Place the QR code inside the area
                  </div>
                </div>
              </div>

              <div>
                <div
                  style={{
                    width: "320px",
                    height: "340px",
                    textAlign: "center",
                  }}
                >
                  {isScannerActive ? (
                    <QrScanner
                      onUpdate={(err, result) => {
                        console.log("scan data........", result);
                        if (result) handleScan(result);
                        else handleError(err);
                      }}
                      style={{ width: "320px", height: "320px" }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "320px",
                        height: "320px",
                        color: "#1E1E1E",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {displayMessage}
                    </div>
                  )}
                  {errorMessage && (
                    <div style={{ color: "red" }}>{errorMessage}</div>
                  )}
                </div>
                <div
                  style={{
                    marginTop: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <SlotCloseIcon
                    onClick={closeModal}
                    style={{ cursor: "pointer", width: "48px", height: "48px" }}
                  />{" "}
                  <RefreshIcon
                    onClick={restartScanner}
                    style={{ cursor: "pointer", width: "48px", height: "48px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isMenuOpen && (
        <div
          ref={alertRef}
          style={{
            position: "fixed",
            left: "0",
            top: "0",
            width: "260px",
            height: "100vw",
            zIndex: 100,
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "4px",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            transition: "left 0.3s ease",
          }}
        >
          <div>
            <div
              style={{
                width: "260px",
                height: "54px",
                padding: "16px",
                borderBottom: "1px solid #E5E5E5",
              }}
            >
              <MeetQIcon style={{ marginLeft: "8px" }} />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "8px",
              }}
            >
              <div
                onClick={() => {
                  navigate("/dashboard");
                }}
                style={{
                  cursor: "pointer",
                  width: "228px",
                  height: "44px",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  backgroundColor:
                    selectedMenu === "Dashboard" ? "#FFDEE4" : "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: selectedMenu === "Dashboard" ? "#842234" : "#1E1E1E",
                    paddingLeft: "16px",
                  }}
                >
                  Dashboard
                </div>
              </div>
              <div
                onClick={() => {
                  navigate("/");
                }}
                style={{
                  cursor: "pointer",
                  width: "228px",
                  height: "44px",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  backgroundColor:
                    selectedMenu === "Discover" ? "#FFDEE4" : "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: selectedMenu === "Discover" ? "#842234" : "#1E1E1E",
                    paddingLeft: "16px",
                  }}
                >
                  Discover
                </div>
              </div>
              <div
                onClick={() => {
                  navigate("/mybooking");
                }}
                style={{
                  cursor: "pointer",
                  width: "228px",
                  height: "44px",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  backgroundColor:
                    selectedMenu === "My Bookings" ? "#FFDEE4" : "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color:
                      selectedMenu === "My Bookings" ? "#842234" : "#1E1E1E",
                    paddingLeft: "16px",
                  }}
                >
                  My Bookings
                </div>
              </div>

              <div
                onClick={() => {
                  navigate("/office-list");
                }}
                style={{
                  cursor: "pointer",
                  width: "228px",
                  height: "44px",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  backgroundColor:
                    selectedMenu === "Offices" ? "#FFDEE4" : "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: selectedMenu === "Offices" ? "#842234" : "#1E1E1E",
                    paddingLeft: "16px",
                  }}
                >
                  Offices
                </div>
              </div>

              <div
                onClick={() => {
                  navigate("/room-list");
                }}
                style={{
                  cursor: "pointer",
                  width: "228px",
                  height: "44px",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  backgroundColor:
                    selectedMenu === "Rooms" ? "#FFDEE4" : "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: selectedMenu === "Rooms" ? "#842234" : "#1E1E1E",
                    paddingLeft: "16px",
                  }}
                >
                  Rooms
                </div>
              </div>

              <div
                onClick={() => {
                  navigate("/user-list");
                }}
                style={{
                  cursor: "pointer",
                  width: "228px",
                  height: "44px",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  backgroundColor:
                    selectedMenu === "Users" ? "#FFDEE4" : "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: selectedMenu === "Users" ? "#842234" : "#1E1E1E",
                    paddingLeft: "16px",
                  }}
                >
                  Users
                </div>
              </div>
              <div
                onClick={() => {
                  navigate("/report");
                }}
                style={{
                  cursor: "pointer",
                  width: "228px",
                  height: "44px",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  backgroundColor:
                    selectedMenu === "Report" ? "#FFDEE4" : "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: selectedMenu === "Report" ? "#842234" : "#1E1E1E",
                    paddingLeft: "16px",
                  }}
                >
                  Report
                </div>
              </div>
              {/*  <div onClick={()=>{}} style={{ width: '228px',height: '44px',  borderRadius: '12px',  display:'flex',justifyContent:"left", alignItems:"center", backgroundColor: selectedMenu ==='Invoices'?'#FFDEE4':'#FFFFFF' }}>
          <div style={{ fontSize:"14px", fontWeight:"500", color: selectedMenu ==='Invoices'?'#842234':'#1E1E1E', paddingLeft:'16px' }}>Invoices</div>   
             </div> */}
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default Header;
